import { cloneDeep } from 'lodash';
import {
  RESET_ALL_ANALYSIS_DATA,
  SET_ANALYSIS_HEATMAPS_DATA,
  SET_ANALYSIS_JOURNEYMAP_DATA,
  SET_ANALYSIS_AGGREGATE_JOURNEYMAP_DATA,
  SET_ANALYSIS_CIRCUMPLEX_DATA,
  SET_ANALYSIS_VIDEO_DATA,
  SET_ANALYSIS_DATASET,
} from './consts';

const appInitialState = {
  heatmaps: [],
  journeyMap: [],
  aggregateJourneyMap: [],
  circumplex: [],
  dataSet: [],
  video: []
};

const analysisDataReducer = (state = appInitialState, action) => {
  switch (action.type) {
    case SET_ANALYSIS_VIDEO_DATA:
      return { ...state, video: action.video };
    case SET_ANALYSIS_HEATMAPS_DATA:
      return { ...state, heatmaps: action.heatmaps };
    case SET_ANALYSIS_JOURNEYMAP_DATA:
      return { ...state, journeyMap: action.journeyMap };
    case SET_ANALYSIS_AGGREGATE_JOURNEYMAP_DATA:
      return { ...state, aggregateJourneyMap: action.aggregateJourneyMap };
    case SET_ANALYSIS_CIRCUMPLEX_DATA:
      return { ...state, circumplex: action.circumplex };
    case SET_ANALYSIS_DATASET:
      return { ...state, dataSet: action.dataSet };
    case RESET_ALL_ANALYSIS_DATA:
      return cloneDeep(appInitialState);
    default:
      return state;
  }
};

export default analysisDataReducer;



// WEBPACK FOOTER //
// ./src/scenes/analysis/data/analysis/analysisDataReducer.js